








































import Vue, { VueConstructor } from 'vue'
import { notes, Note } from '../application/models/notes'
import { majorChord, minorChord, diminishedChord, augmentedChord, major7th, minor7th, dominant7th, minor7thFlat5, minorMajor7, major7thSharp5, diminished7th, Chord } from '../application/models/chords'
import { SelectableT, selectRandom } from '../application/models/selectable'
import hasBreakpoints, { HasBreakpointsMixinComputed } from '@/mixins/hasBreakpoints'
import hasEnharmonics, { HasEnharmonicsMixinData } from '@/mixins/hasEnharmonics'

type Mixins = HasBreakpointsMixinComputed & HasEnharmonicsMixinData

export default (Vue as VueConstructor<Mixins>).extend({
  mixins: [hasBreakpoints, hasEnharmonics],
  data () {
    const selectableNotes = notes.map(n => new SelectableT(n, true))
    const selectableChords = [
      new SelectableT(majorChord, true),
      new SelectableT(minorChord, true),
      new SelectableT(diminishedChord, true),
      new SelectableT(augmentedChord, true),
      new SelectableT(major7th, true),
      new SelectableT(minor7th, true),
      new SelectableT(dominant7th, true),
      new SelectableT(minor7thFlat5, true),
      new SelectableT(minorMajor7, true),
      new SelectableT(major7thSharp5, true),
      new SelectableT(diminished7th, true)
    ]
    return {
      note: selectableNotes[0],
      chord: selectableChords[0],
      selectableNotes,
      selectableChords
    }
  },
  beforeMount () {
    this.randomize()
  },
  computed: {
    availableNotes (): SelectableT<Note>[] {
      return this.selectableNotes.filter(n => n.selected)
    },
    availableChords (): SelectableT<Chord>[] {
      return this.selectableChords.filter(n => n.selected)
    },
    canRandomize (): boolean {
      return this.availableNotes.length > 0 && this.availableChords.length > 0
    }
  },
  methods: {
    randomize() {
      this.note = selectRandom(this.availableNotes)
      this.chord = selectRandom(this.availableChords)
    }
  }
})
